<template>
  <div v-if="question.otherOptionContentField">
    <label>
      <input type="radio" disabled />&nbsp;<span class="color_959fa4">{{ question.otherOptionContentField }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "other-option",
  props: {
    question: {
      type: Object,
      required: true
    }
  }
};
</script>
